import { TableDataType } from 'module/ui/components/atoms/rich-text-editor/toolbar/table-toolbar';
import { BaseCustomSectionAttributes, CustomSectionType } from './common';

export enum AnswerLength {
  TwentyWords = 20,
  HundredWords = 100,
  TwoHundredWords = 200,
  FiveHundredWords = 500,
}

export type QuestionAnswerItemCustomSectionConfig = {
  question: string;
  answer?: string;
  dataType?: TableDataType;
  answerLength?: AnswerLength | null;
  answerFrom?: string;
  choices?: string[];
  generateNewChoices?: boolean;
  aiContext?: string;
};

export type QuestionAnswerItemCustomSectionAttributes =
  BaseCustomSectionAttributes & {
    sectionType: CustomSectionType.QuestionAnswerItem;
    config: QuestionAnswerItemCustomSectionConfig;
  };
